class TreeviewsService {
    constructor() {
        this._renderedElements = ( new Map());
    }
    getRenderedTreeElement(node) {
        if (( this._renderedElements.has(node))) {
            return this._renderedElements.get(node);
        }
        return undefined;
    }
    addRenderedTreeItemElement(node, element) {
        this._renderedElements.set(node, element);
    }
    removeRenderedTreeItemElement(node) {
        if (( this._renderedElements.has(node))) {
            this._renderedElements.delete(node);
        }
    }
}

export { TreeviewsService };
